var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { client as braintreeClient, localPayment, dataCollector, } from "braintree-web";
import { usePayment } from "../../app/usePayment";
import { useNotifications } from "../../app/useNotifications";
import { useLoader } from "../../app/useLoader";
import { renderMaskButtonClasses } from "../../styles";
export var LocalPaymentMethodMask = function (_a) {
    var saveLocalPaymentIdUrl = _a.saveLocalPaymentIdUrl, paymentType = _a.paymentType, countryCode = _a.countryCode, currencyCode = _a.currencyCode, _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, buttonText = _a.buttonText, merchantAccountId = _a.merchantAccountId, fallbackUrl = _a.fallbackUrl, fallbackButtonText = _a.fallbackButtonText, shippingAddressRequired = _a.shippingAddressRequired, useKount = _a.useKount, lineItems = _a.lineItems, shipping = _a.shipping;
    var _c = useState(), localPaymentInstance = _c[0], setLocalPaymentInstance = _c[1];
    var _d = useState(""), deviceData = _d[0], setDeviceData = _d[1];
    var paymentButton = useRef(null);
    var _e = usePayment(), handlePurchase = _e.handlePurchase, paymentInfo = _e.paymentInfo, clientToken = _e.clientToken, setLocalPaymentId = _e.setLocalPaymentId;
    var notify = useNotifications().notify;
    var isLoading = useLoader().isLoading;
    var invokePayment = function (e) {
        var overridePaymentVersion;
        e.preventDefault();
        if (!localPaymentInstance) {
            notify("Error", "No payment instance");
            return;
        }
        isLoading(true);
        localPaymentInstance.startPayment({
            paymentType: paymentType,
            amount: paymentInfo.amount,
            fallback: {
                url: fallbackUrl,
                buttonText: fallbackButtonText,
            },
            email: paymentInfo.cartInformation.account.email,
            givenName: paymentInfo.cartInformation.billing.firstName,
            surname: paymentInfo.cartInformation.billing.lastName,
            countryCode: countryCode,
            paymentTypeCountryCode: countryCode,
            currencyCode: currencyCode,
            shippingAddressRequired: shippingAddressRequired,
            onPaymentStart: function (data, start) {
                setLocalPaymentId(data.paymentId, saveLocalPaymentIdUrl).then(function (result) {
                    overridePaymentVersion = result;
                    start();
                });
            },
        }, function (startPaymentError, payload) {
            if (startPaymentError) {
                isLoading(false);
                if (startPaymentError.code === "LOCAL_PAYMENT_POPUP_CLOSED") {
                    notify("Error", "Customer closed Local Payment popup.");
                }
                else {
                    notify("Error", startPaymentError.message);
                }
            }
            else {
                if (payload) {
                    var handlePurchaseOptions = {
                        deviceData: deviceData,
                        lineItems: lineItems,
                        shipping: shipping,
                    };
                    if (merchantAccountId) {
                        handlePurchaseOptions.merchantAccountId = merchantAccountId;
                    }
                    handlePurchase(payload.nonce, handlePurchaseOptions, overridePaymentVersion);
                }
                else {
                    isLoading(false);
                    notify("Error", "No payload received");
                }
            }
        });
    };
    useEffect(function () {
        braintreeClient.create({
            authorization: clientToken,
        }, function (clientError, clientInstance) {
            isLoading(true);
            if (clientError) {
                isLoading(false);
                notify("Error", clientError.message);
                return;
            }
            var localPaymentAuthOption = merchantAccountId
                ? { merchantAccountId: merchantAccountId }
                : { authorization: clientToken };
            localPaymentAuthOption.client = clientInstance;
            localPayment.create(localPaymentAuthOption, function (localPaymentError, paymentInstance) {
                if (localPaymentError) {
                    isLoading(false);
                    notify("Error", localPaymentError.message);
                    return;
                }
                dataCollector.create({
                    client: clientInstance,
                    kount: useKount !== null && useKount !== void 0 ? useKount : undefined,
                }, function (dataCollectorErr, dataCollectorInstance) {
                    if (!dataCollectorErr && dataCollectorInstance) {
                        setDeviceData(dataCollectorInstance.deviceData);
                    }
                });
                setLocalPaymentInstance(paymentInstance);
                isLoading(false);
            });
        });
    }, [clientToken, merchantAccountId]);
    return (_jsx("button", __assign({ onClick: invokePayment, ref: paymentButton, className: renderMaskButtonClasses(fullWidth, !!localPaymentInstance, !localPaymentInstance) }, { children: buttonText })));
};
